import React, { useContext } from "react";

import Styles from "./LifeatVahak.module.scss";

import { AppContext } from "@vahak/core/dist/app-context";
import ScrollableContainer from "@vahak/core/dist/components/scrollable-container/ScrollableContainer";
// import "./LifeatVahak.scss";
import LifeatVahakImage from "./lifeat-vahak-image/LifeatVahakImage";

const vahakLifeImages = [
    {
        id: 1,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_20-desktop.png`,
        title: "vahak-team-party-20"
    },
    {
        id: 2,
        widthLarge: 195,
        widthSmall: 154,
        imageurlLarge: `akshay_10-desktop.png`,
        title: "Akshay"
    },
    {
        id: 3,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `anshul_10-desktop.png`,
        title: "Anshul"
    },
    {
        id: 6,
        widthLarge: 526,
        widthSmall: 416,
        imageurlLarge: `group_11-desktop.png`,
        title: "vahak-team-party-11"
    },
    {
        id: 4,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `atul_10-desktop.png`,
        title: "Atul"
    },
    {
        id: 5,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_10-desktop.png`,
        title: "vahak-team-party-10"
    },
    {
        id: 7,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_12-desktop.png`,
        title: "vahak-team-party-12"
    },
    {
        id: 8,
        widthLarge: 443,
        widthSmall: 350,
        imageurlLarge: `group_19-desktop.png`,
        title: "vahak-team-party-19"
    },
    {
        id: 10,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_18-desktop.png`,
        title: "vahak-team-party-18"
    },
    {
        id: 11,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_13-desktop.png`,
        title: "vahak-team-party-13"
    },
    {
        id: 11,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `krishna_01-desktop.png`,
        title: "Krishna"
    },

    {
        id: 9,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `hiraj_10.png`,
        title: "Hiraj Dey"
    },

    {
        id: 12,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_14-desktop.png`,
        title: "vahak-team-party-14"
    },

    {
        id: 13,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_15-desktop.png`,
        title: "vahak-team-party-15"
    },
    {
        id: 15,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_17-desktop.png`,
        title: "vahak-team-party-17"
    },
    {
        id: 14,
        widthLarge: 526,
        widthSmall: 416,
        imageurlLarge: `group_16-dektop.png`,
        title: "vahak-team-party-16"
    },
    {
        id: 16,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_21-desktop.png`,
        title: "vahak-team-party-21"
    },

    {
        id: 18,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `karrup_01-desktop.png`,
        title: "Karrup"
    },
    {
        id: 19,
        widthLarge: 172,
        widthSmall: 136,
        imageurlLarge: `sharin_10-desktop.png`,
        title: "Sharin"
    },
    {
        id: 17,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: `group_21-desktop.png`,
        title: "vahak-team-party-22"
    },
    {
        id: 20,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `tanu_10-desktop.png`,
        title: "Tanushree"
    },
    {
        id: 21,
        widthLarge: 103,
        widthSmall: 82,
        imageurlLarge: `vidya_10-desktop.png`,
        title: "Vidya"
    },
    {
        id: 22,
        widthLarge: 444,
        widthSmall: 351,
        imageurlLarge: `rohit_10-desktop.png`,
        title: "Rohit"
    },
    {
        id: 24,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `group_01-desktop.png`,
        title: "vahak-team-party-01"
    },
    {
        id: 23,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: `avadhesh_web_pic-desktop.png`,
        title: "Avadhesh Maurya"
    },

    {
        id: 25,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: `neel_01-desktop.png`,
        title: "Indraneel Dutta"
    },
    {
        id: 26,
        widthLarge: 263,
        widthSmall: 208,
        imageurlLarge: `suresh_01-desktop.png`,
        title: "Suresh"
    },
    {
        id: 29,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `group_05-desktop.png`,
        title: "vahak-team-party-05"
    },
    {
        id: 27,
        widthLarge: 244,
        widthSmall: 197,
        imageurlLarge: `shrey_01-desktop.png`,
        title: "Shrey"
    },
    {
        id: 28,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `karrup_01-desktop.png`,
        title: "Karrup"
    },
    {
        id: 32,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `group_03-desktop.png`,
        title: "vahak-team-party-03"
    },

    {
        id: 30,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `group_04-desktop.png`,
        title: "vahak-team-party-04"
    },

    {
        id: 33,
        widthLarge: 260,
        widthSmall: 206,
        imageurlLarge: `ali_01-desktop.png`,
        title: "Ali"
    },
    {
        id: 34,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: `group_06-desktop.png`,
        title: "vahak-team-party-06"
    },
    {
        id: 35,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: `chintan_01-desktop.png`,
        title: "Chintan"
    },
    {
        id: 31,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `group_02-desktop.png`,
        title: "vahak-team-party-02"
    },
    {
        id: 32,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `offsite-image-5.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 33,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `offsite-image-1.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 34,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `offsite-image-2.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 35,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `offsite-image-3.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 36,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `offsite-image-4.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 37,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `offsite-image-6.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 38,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `badminton-tournament.JPG`,
        title: "vahak-badminton-tournament"
    },
    {
        id: 39,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `offsite-image-8.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 40,
        widthLarge: 240,
        widthSmall: 335,
        imageurlLarge: `vahak-womensgroup.jpg`,
        title: "vahak-girls"
    },
    {
        id: 41,
        widthLarge: 400,
        widthSmall: 260,
        imageurlLarge: `birthdayboysgirls.jpg`,
        title: "vahak-birthda-party"
    },
    {
        id: 42,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `ethnic-dressing-1.JPG`,
        title: "vahak-ethnic"
    },
    {
        id: 43,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `ethnic-dressing-4.JPG`,
        title: "vahak-ethnic"
    },
    {
        id: 45,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `ethnic-dressing-3.JPG`,
        title: "vahak-ethnic"
    },
    {
        id: 46,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `ethnic-dressing-2.JPG`,
        title: "vahak-ethnic"
    },
    {
        id: 47,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: `offsite-image-7.jpg`,
        title: "vahak-offsite"
    },
    {
        id: 48,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `ethnic-dressing-5.JPG`,
        title: "vahak-ethnic"
    },
    {
        id: 49,
        widthLarge: 340,
        widthSmall: 263,
        imageurlLarge: `photoshoot-4.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 50,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `photoshoot-10.jpg`,
        title: "vahak-photoshoot"
    },
    {
        id: 51,
        widthLarge: 330,
        widthSmall: 263,
        imageurlLarge: `photoshoot-14.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 52,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `photoshoot-15.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 53,
        widthLarge: 300,
        widthSmall: 263,
        imageurlLarge: `photoshoot-9.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 54,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `photoshoot-8.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 55,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: `photoshoot-3.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 56,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `photoshoot-12.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 57,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: `photoshoot-2.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 58,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `photoshoot-1.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 59,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: `photoshoot-11.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 60,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: `join-our-fam.JPG`,
        title: "vahak-photoshoot"
    },
    {
        id: 61,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: `photoshoot-13.JPG`,
        title: "vahak-photoshoot"
    }
];

vahakLifeImages.reverse();
const _vahakLifeImages1 = vahakLifeImages.slice(0, vahakLifeImages.length / 2);
const _vahakLifeImages2 = vahakLifeImages.slice(vahakLifeImages.length / 2);
const vahakLifeImages1: typeof vahakLifeImages = [];
const vahakLifeImages2: typeof vahakLifeImages = [];

Array(8)
    .fill(undefined)
    .forEach(() => {
        vahakLifeImages1.push(..._vahakLifeImages1);
        vahakLifeImages2.push(..._vahakLifeImages2);
    });

const LifeatVahak = () => {
    const { isMobile } = useContext(AppContext);

    return (
        <div className={Styles.lifeAtVahakRow}>
            <div className="container">
                <h2>
                    Behind the{" "}
                    <span data-hover="Wheel at Vahak" className={isMobile ? "" : "indaiText"}>
                        Wheel at Vahak
                    </span>
                </h2>
            </div>
            <ScrollableContainer
                containerClass={Styles.scrollableContainer}
                length={vahakLifeImages1?.length}
                scrollBy={3}
                autoScroll="SCROLL_RL"
                isNavShadow={false}
                showNavArrows={false}
                items={vahakLifeImages1.map((vahaklifeImage, i) => (
                    <LifeatVahakImage key={String(i)} lifeatVahakImg={vahaklifeImage} />
                ))}
            />
            <ScrollableContainer />

            <ScrollableContainer
                containerClass={Styles.scrollableContainer}
                length={vahakLifeImages2?.length}
                scrollBy={3}
                autoScroll="SCROLL_LR"
                isNavShadow={false}
                showNavArrows={false}
                items={vahakLifeImages2.map((vahaklifeImage, i) => (
                    <LifeatVahakImage key={String(i)} lifeatVahakImg={vahaklifeImage} />
                ))}
            />
            <ScrollableContainer />
        </div>
    );
};

export default LifeatVahak;
